import { render, staticRenderFns } from "./userControl.vue?vue&type=template&id=0bce1cfb"
import script from "./userControl.vue?vue&type=script&lang=js"
export * from "./userControl.vue?vue&type=script&lang=js"
import style0 from "./userControl.vue?vue&type=style&index=0&id=0bce1cfb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports